import { IUserHttpService } from '../interfaces';
import { firstValueFrom } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserResponseBack } from '../interfaces/types';
import { ERROR_ACTION_KEY } from '../../../tokens';

@Injectable()
export class UserHttpService implements IUserHttpService {
  constructor(private httpClient: HttpClient) {}

  getMe(): Promise<UserResponseBack> {
    return firstValueFrom(
      this.httpClient.get<UserResponseBack>(`/me`, {
        context: new HttpContext().set(ERROR_ACTION_KEY, 'errors.actions.user_profile'),
      }),
    );
  }
}
